import PropTypes from "prop-types";

export const TodoPropTypes = {
  summary: PropTypes.string,
  description: PropTypes.string,
  due_date: PropTypes.number,
  id: PropTypes.number,
  completed: PropTypes.bool,
  assignee_user_id: PropTypes.number,
};

export const TodoShapePropTypes = PropTypes.shape(TodoPropTypes);
